import { faSpinner } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { styled } from "@mui/material/styles"
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer"
import { useEffect, useState } from "react"
import { CertificateDocument } from "./CertificateDocument"
import { useTranslation } from "react-i18next"

const StyledPDFViewer = styled(PDFViewer)({
  height: "600px",
  width: "100%"
})

const StyledPDFDownloadLink = styled(PDFDownloadLink)({
  textDecoration: "none"
})

export const CertificateRender = ({ item }) => {
  return (
    <StyledPDFViewer>
      <CertificateDocument
        examinationCertificate={item.examinationCertificate}
        userFullName={item.userFullName}
        examinationName={item.examinationName}
        completedDate={item.completedDate}
      />
    </StyledPDFViewer>
  )
}
export const CertificateDownloadLink = ({ item, children }) => {
  const [docItem, setDocItem] = useState()
  const { t } = useTranslation()

  useEffect(() => {
    setDocItem(item)
  }, [item])

  return docItem ? (
    <StyledPDFDownloadLink
      document={
        <CertificateDocument
          examinationCertificate={docItem.examinationCertificate}
          userFullName={docItem.userFullName}
          examinationName={docItem.examinationName}
          completedDate={docItem.completedDate}
        />
      }
      fileName={`${t("learning.result.titles.certificate", "Certificate")}-${docItem.userFullName}`}>
      {({ blob, url, loading, error }) => {
        return loading ? (
          <FontAwesomeIcon
            style={{ color: "rgba(0, 0, 0, 0.54)", padding: "10px", fontSize: "21px" }}
            icon={faSpinner}
            spin
            size="xs"
          />
        ) : (
          children
        )
      }}
    </StyledPDFDownloadLink>
  ) : null
}
